import moment from 'moment';
import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {AppDatePicker, Col, UiBox, UiImage, UiQuestionnaireLayout, UiText} from '~/components/elements';
import {MENSTRUAL_HEALTH_KEYS} from '~/constants/medical-questionnaires';
import {useInput, useNotification} from '~/hooks';
import {setNextQuestionnaire, setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import {spacing} from '~/utils/theme/spacing';

const Questionnaire4Screen = () => {
  const dispatch: AppDispatch = useDispatch();
  const {addMessage} = useNotification(dispatch);
  const [startDate, setStartDate] = useState(new Date());

  const currentAnswer = useSelector(
    (state: RootState) => state.questionnaires?.collectData[MENSTRUAL_HEALTH_KEYS.LAST_PERIOD_AT]?.data,
  );

  const {inputs, setInputs} = useInput({
    lastStartDatePeriod: currentAnswer?.lastStartDatePeriod || new Date().toISOString(),
  });

  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);

  const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = questionnaires?.find(i => i.key === MENSTRUAL_HEALTH_KEYS.LAST_PERIOD_AT);

  const onChange = (dates: Date) => {
    setInputs({lastStartDatePeriod: dates.toISOString()});
  };

  const onClickSubmit = async () => {
    dispatch(
      setQuestionnaireAnswer({
        key: MENSTRUAL_HEALTH_KEYS.LAST_PERIOD_AT,
        index: questionnaire?.index || '',
        data: inputs,
      }),
    );
    dispatch(setNextQuestionnaire({value: MENSTRUAL_HEALTH_KEYS.PERIODS_USUAL_LAST_FOR}));
  };

  return (
    <UiQuestionnaireLayout
      actions={questionnaire?.actions}
      disableNext={!inputs.lastStartDatePeriod}
      handleOnNext={onClickSubmit}
      checkoutStep={questionnaire?.checkoutStep}
    >
      <Col alignItems="center" textAlign="center">
        <UiImage type="icon" name={questionnaire?.icon} boxSize={spacing.mLarge} mt={spacing.medium} />
        <UiText fontSize="xl" fontWeight="bold" mt={spacing.large}>
          {questionnaire?.questions?.default}
        </UiText>
        <UiBox my={spacing.large}>
          <AppDatePicker maxDate={moment().toDate()} selected={inputs.lastStartDatePeriod} onChange={onChange} inline />
        </UiBox>
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire4Screen;
